import React from 'react';

import { CDN_URL, getCdnImageUrl } from '@utils/cloudflare';
import StarRating from '@components/common/StarRating';

import ImageLoaded from '@components/common/ImageLoaded/ImageLoaded';
import { isValidHttpUrl } from '../utils';

export type TestimonialCardProps = {
  imageUrl: string;
  hotelName: string;
  product?: string;
  rating?: number;
  description?: string;
  clientName?: string;
  url?: string;
};

export default function TestimonialCard({
  imageUrl,
  hotelName,
  product,
  rating,
  description,
  clientName,
  url,
}: TestimonialCardProps) {
  const isUrl = isValidHttpUrl(imageUrl);
  const hotelImage = isUrl ? imageUrl : getCdnImageUrl(720, imageUrl, CDN_URL);
  return (
    <div className="flex flex-col d:gap-6 gap-2 d:flex-row d:max-w-951 d:h-196">
      <div className="max-w-179 w-full">
        <a href={url} target="_blank" rel="noreferrer">
          <ImageLoaded url={hotelImage} classes="rounded" alt={hotelName} />
        </a>
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex flex-col gap-2 ml-2 d:ml-0">
          <h1 className="font-bold text-sm font-rp-basetica-bold text-rp-neutral">{hotelName}</h1>
          <p className="text-sm text-rp-neutral">Product Purchased: {product}</p>
        </div>
        <div className="flex text-rp-primary-redesign ml-2 d:ml-0">
          <StarRating rating={rating?.toString() || ''} size="4" isDesignSystemStar />
        </div>
        <div className="flex flex-col gap-2 ml-2 d:ml-0">
          <p className="text-base text-rp-shadow">“{description}“</p>
          <span className="text-sm text-rp-neutral">{clientName}</span>
        </div>
      </div>
    </div>
  );
}

TestimonialCard.defaultProps = {
  product: '',
  rating: 0,
  description: '',
  clientName: '',
  url: '',
};
